export const TERMIX_TIMEFRAMES = ['1m', '5m', '15m', '30m', '1h', '4h', '1d', '1w'];
export const isTermixTimeframe = (value) => TERMIX_TIMEFRAMES.includes(value);
/** Bar length in seconds for padding the time scale into the future. */
export const timeframeSeconds = (tf) => {
    switch (tf) {
        case '1m': return 60;
        case '5m': return 5 * 60;
        case '15m': return 15 * 60;
        case '30m': return 30 * 60;
        case '1h': return 60 * 60;
        case '4h': return 4 * 60 * 60;
        case '12h': return 12 * 60 * 60;
        case '1d': return 24 * 60 * 60;
        case '1w': return 7 * 24 * 60 * 60;
        default: return 15 * 60;
    }
};
/** Live poll / first paint — keep 1m light. */
export const liveCandleLimit = (tf) => {
    switch (tf) {
        case '1m': return 720; // ~12h
        case '5m': return 1000; // ~3.5d
        default: return 1000;
    }
};
/**
 * Optional deep history target (bars). null = no “load more” for this TF.
 * Minutes stay short on purpose.
 */
export const deepHistoryTarget = (tf) => {
    switch (tf) {
        case '1m':
        case '5m':
            return null;
        case '15m': return 3000; // ~1 month
        case '30m': return 3500; // ~2.5 months
        case '1h': return 4500; // ~6 months
        case '4h': return 2200; // ~1 year
        case '1d': return 730; // ~2 years
        case '1w': return 260; // ~5 years
        default: return null;
    }
};
/** Hard cap held in RAM / chart for a tab. */
export const maxHeldCandles = (tf) => Math.max(liveCandleLimit(tf), deepHistoryTarget(tf) ?? 0);
